module.exports = __webpack_public_path__ + "static/MICHELIN-774f630d6c84886647e4cfc12f397401.svg";